import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton, SecondaryButton } from '../common/Buttons';
import HostingHeroBg from '../images/hosting-hero.jpg';
import './style.css';

function HeroSection() {
  return (
    <section
      id="hosting-hero"
      className="hosting-hero-section"
      style={{
        backgroundImage: `url(${HostingHeroBg})`,
      }}
    >
      <div className="hosting-hero-overlay" />
      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row className="justify-content-center text-center">
          <Col md="10" lg="8">
            <h1 className="hosting-hero-title">
              Premium WordPress Hosting{' '}
              <span className="hosting-hero-highlight">
                for Businesses That Demand More
              </span>
            </h1>
            <p className="hosting-hero-subtitle">
              Fast, secure, scalable — with the option to pay in 30 days. Launch your website today and pay later.
            </p>
            <div className="hosting-hero-btns">
              <PrimaryButton href="#plans">View Hosting Plans</PrimaryButton>
              <SecondaryButton href="./Net-30">Request NET 30</SecondaryButton>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HeroSection;
